<template>
    <div v-if="mostrarFiltrarDespesas">
        <b-button-group class="float-right mr-2">
            <b-button
                variant="primary"
                @click="abrirModal()"
            >
                <i class="fa fa-search"></i> 
                Filtrar despesas
            </b-button>
        </b-button-group>
        <b-modal 
            v-model="mostrarModal" 
            size="lg"
        >
            <div slot="modal-title">
                Filtros de despesas gerais
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
            <b-col sm="12" md="9">
                    <b-form-group v-if="!fornecedorExterno">
                        <label class="required" for="cpfcnpj">CPF/CNPJ Formecedor</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                id="cpfcnpj"
                                placeholder="Digite o CPF ou CNPJ do fornecedor"
                                v-model="fornecedorCPFCNPJ"
                                v-mask="[
                                    '###.###.###-##',
                                    '##.###.###/####-##'
                                ]"
                            ></b-form-input>
                            <b-form-invalid-feedback>
                                O CPF ou CNPJ do fornecedor é obrigatório
                            </b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group v-if="fornecedorExterno">
                        <label class="required" for="codCfo">Código Formecedor</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                id="codCfo"
                                maxlength="8"
                                placeholder="Digite o Código do fornecedor"
                                v-model="fornecedorCodCfo"
                                v-mask="[
                                    '########',
                                ]"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md=3>
                    <b-form-group>
                        <label>
                        </label>
                        <b-checkbox
                            v-model="fornecedorExterno"
                        >
                            Fornecedor Estrangeiro
                        </b-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-form-group>
                <label for="seq">Sequencial</label>
                <b-input-group>
                    <b-form-input
                        type="text"
                        id="seq"
                        placeholder="Digite o sequencial da despesa"
                        v-model="sequencial"
                        v-mask="'############'"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                    </b-form-invalid-feedback>
                </b-input-group>
            </b-form-group>
            <b-form-group>
                <label for="movimentoid">Id do movimento</label>
                <b-input-group>
                    <b-form-input
                        type="text"
                        id="movimentoid"
                        placeholder="Digite o id do movimento da despesa no RM"
                        v-model="movimentoId"
                        v-mask="'############'"
                    ></b-form-input>
                </b-input-group>
            </b-form-group>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    @click.stop="obterDespesasFiltradas()"
                    class="ml-2"
                    :disabled="$v.$invalid"
                >
                    <span> Filtrar</span>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },
    }, 

    data() {
        return {
            mostrarModal: false,
            erros: [],
            fornecedorCPFCNPJ: null,
            sequencial: null,
            movimentoId: null,
            fornecedorCodCfo: null,
            fornecedorExterno: false,
        }
    },  

    methods: {
        obterDespesasFiltradas() {
            this.$store.dispatch("addRequest")
            let filtroDto = {
                cpfCnpjCodCfo: this.fornecedorExterno ? this.fornecedorCodCfo : this.fornecedorCPFCNPJ ? this.fornecedorCPFCNPJ.apenasNumeros() : null,
                fornecedorExterno: this.fornecedorExterno,
                sequencial: this.sequencial,
                movimentoId: this.movimentoId
            }
            this.pagamentosServicos.obterDespesasCompraOutroFornecedor(
                this.pagamento.pagamentoId,
                filtroDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('despesasFiltradas', response.data)
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch("removeRequest")
            })
        },

        abrirModal() {
            this.fornecedorCPFCNPJ = null
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.fornecedor = {}
        },
    },

    computed: {
        validaTamanhoCpfCnpj() {
            if (this.fornecedorCPFCNPJ == null || this.fornecedorCPFCNPJ == '') {
                return true
            }
            if (this.fornecedorCPFCNPJ != null) {
                return (
                    this.fornecedorCPFCNPJ.length == '14' ||
                    this.fornecedorCPFCNPJ.length == '18'
                )
            }
            return false
        },

        mostrarFiltrarDespesas() {
            return this.$temAcessoView('DESP-GERAIS-REQ-08')
                && this.$route.name === 'DespesasGerais_Requisitantes_Pagamentos_AssociarDespesas'
        }
    },

    watch: {
        fornecedorExterno() {
            this.fornecedorCPFCNPJ = null
            this.fornecedorCodCfo = null
        }
    },

    validations: {
        fornecedorCPFCNPJ: {
            obrigatorio() {
                return this.validaTamanhoCpfCnpj
            }
        },
    },
}

</script>